import './featured-articles';
import './featured-patrimony';
import './social-networks';
import './search';
import './header-fixed';
import './widget';